import React from "react";
import i18n from "../../../i18n";
import { Spinner, Callout } from "@blueprintjs/core";
import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import { Trans } from "react-i18next";
import { FinancialTable } from "../../Structure/navbar/blueprintTableincludes";



export default class TableByEq extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      columns: [],
      loading: true
    };
  }

  ac = new AbortController();

  componentDidMount() {
    this.setState({ loading: true });
    if (this.props.urlsearchparams !== undefined) {
      authenticatedGetFetch('/financial/byDevice?' + this.props.urlsearchparams,
        (res) => {
          //add the first column containing the equipment id
          const columns = [{
            title: i18n.t("equipment"),
            field: "id",
            render: (data) => <Trans>{data}</Trans>
          }];

          //add the columns according the used means of payment
          for (const l of res['lbl']) {
            columns.push({
              title: i18n.t("mop" + l),
              field: l
            })
          }

          //add a column for total
          columns.push({
            title: "Total",
            field: "total"
          });
          this.setState({ loading: false, data: res['data'], columns: columns });
        }, null, this.ac.signal);
    }
  }

  componentWillUnmount() {
    this.ac.abort();
  }

  render() {
    return (this.props.urlsearchparams !== undefined) ?
      <Callout title={<Trans>by equipment</Trans>}>
        {(this.state.loading || this.state.data === undefined || this.state.data === undefined) ?
          <Spinner />
          : <FinancialTable
            columns={this.state.columns}
            data={this.state.data}
            displayCount={this.props.displayCount}
            printing={this.props.printing}
            title="be"
          />
        }
      </Callout>
      : null;
  }
}